import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { Pill } from '@iwoca/orion';
import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import { CreditCardFAQs } from './FAQs';
import { MobileAppWidget } from './MobileAppWidget';
import { QuickLinks } from './quickLinks/QuickLinks';

export const CreditCardDashboard = () => {
    return (
        <div className="grid grid-cols-4 gap-3xl bg-structure-100 px-[150px] py-3xl">
            <div className="col-span-full flex flex-row items-center">
                {/* Dashboard title */}
                <Text className="m-0 text-3xl font-bold max-sm:text-xl">
                    <FormattedMessage
                        id="_.credit_card.dashboard.title"
                        defaultMessage="Your iwoca Credit Card account"
                    />
                </Text>

                <div className="mx-m">
                    <Pill variant="green" size="small">
                        <FormattedMessage
                            id="_.credit_card.dashboard.active"
                            defaultMessage="Active"
                        />
                    </Pill>
                </div>
            </div>
            <div className="col-span-3">
                {/* Account Overview */}
                <div className="col-span-5 max-sm:col-span-full max-sm:mr-xl max-sm:pb-0">
                    <div className="flex flex-row gap-xl max-sm:flex-col">
                        {/* Account Balance */}
                        <div
                            className="mr-l flex flex-col justify-between pr-l max-sm:col-span-full"
                            // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                            aria-label="account-balance"
                        >
                            <span>
                                <Text className="text-l font-med">
                                    <FormattedMessage
                                        id="_.credit_card.dashboard.account_balance"
                                        defaultMessage="Account balance"
                                    />
                                </Text>
                                <Text className="text-xs font-reg">
                                    <FormattedMessage
                                        id="_.credit_card.dashboard.account_balance_subtext"
                                        defaultMessage="Inc. any accrued interest at a rate of 35.4% APR."
                                    />
                                </Text>
                            </span>
                            <Text className="mt-xs text-2xl font-med">
                                <FormattedCurrency value={100} />
                            </Text>
                            <Text className="mt-s text-xs font-med">
                                <FormattedMessage
                                    id="_.credit_card.dashboard.available_credit"
                                    defaultMessage="Available credit: £1000.00"
                                />
                            </Text>
                        </div>
                        <div className="flex flex-row max-sm:flex-row-reverse min-l:gap-m min-xl:gap-5xl">
                            {/* Payment Due */}
                            <div
                                className="flex flex-1 flex-col justify-between"
                                // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                                aria-label="payment-due"
                            >
                                <span>
                                    <Text className="text-l font-med">
                                        <FormattedMessage
                                            id="_.credit_card.dashboard.payment_due"
                                            defaultMessage="Upcoming payment due"
                                        />
                                    </Text>
                                    <Text className="text-xs font-reg">
                                        <FormattedMessage
                                            id="_.credit_card.dashboard.payment_preference"
                                            defaultMessage="You’ve chosen to make min. due payments."
                                        />
                                    </Text>
                                </span>
                                <Text className="mt-xs text-2xl font-med">
                                    <FormattedCurrency value={100} />
                                </Text>
                                <Text className="mt-s text-xs font-med">
                                    <FormattedMessage
                                        id="_.credit_card.dashboard.payment_date"
                                        defaultMessage="To be paid by 8th Nov 2025"
                                    />
                                </Text>
                            </div>
                        </div>
                    </div>
                </div>
                <MobileAppWidget />
            </div>
            <div className="col-span-1">
                <QuickLinks />
                <CreditCardFAQs />
            </div>
        </div>
    );
};
